
import AppClientHeading from "@/components/layout-editor/ClientHeading.vue";
import AppHeading from "@/components/layout-editor/Heading.vue";
import AppLogo from "@/components/layout-editor/Logo.vue";
import AppPage from "@/components/layout-editor/Page.vue";
import AppSectionSplitter from "@/components/layout-editor/SectionSplitter.vue";
import { DocumentLayoutLogo } from "@/utils/documents/layout-logo";
import { ReminderLayout } from "@/utils/reminder-layouts/reminder-layout";
import { mmToPx } from "@/utils/screen";
import Vue from "vue";
import AppFreeLines from "./FreeLines.vue";
import AppTable from "./Table.vue";
import AppText from "./Text.vue";
import AppFreeBlock from "./FreeBlock.vue";
import { FreeBlock } from "@/utils/documents/free-block";

export default Vue.extend({
	props: {
		layout: Object as () => ReminderLayout,
		zoomLevel: Number,
		lang: String,
		showGrid: Boolean
	},
	computed: {
		headerLogos(): DocumentLayoutLogo[] {
			return this.layout.getLogosByPlacement("Heading");
		},
		bodyLogos(): DocumentLayoutLogo[] {
			return this.layout.getLogosByPlacement("Body");
		},
		footerLogos(): DocumentLayoutLogo[] {
			return this.layout.getLogosByPlacement("Footer");
		},
		headerFreeBlocks():FreeBlock[] {
			return this.layout.getFreeBlocksByPlacement("Heading");
		},
		bodyFreeBlocks():FreeBlock[] {
			return this.layout.getFreeBlocksByPlacement("Body");
		},
		footerFreeBlocks():FreeBlock[]{
			return this.layout.getFreeBlocksByPlacement("Footer");
		},
	},
	methods: {
		mmToPx
	},
	components: {
		AppPage,
		AppHeading,
		AppClientHeading,
		AppLogo,
		AppText,
		AppTable,
		AppFreeLines,
		AppSectionSplitter,
		AppFreeBlock
	},
});
